import * as React from 'react';
export const kickstarterSvg = React.forwardRef(function kickstarterSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#05CE78',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm22.352 16.005 2.053-1.987a5.17 5.17 0 0 0 0-7.469c-2.127-2.059-5.591-2.059-7.718 0l-.748.723A5.497 5.497 0 0 0 11.454 5C8.443 5 6 7.364 6 10.278v11.444C6 24.636 8.443 27 11.454 27a5.497 5.497 0 0 0 4.485-2.272l.748.723c2.127 2.058 5.591 2.058 7.718 0a5.17 5.17 0 0 0 0-7.47l-2.053-1.976Z',
      fill: '#fff',
    }),
  );
});
kickstarterSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kickstarter = {
  category: 'brand',
  colorable: false,
  name: 'kickstarter',
  svg: kickstarterSvg,
};
